import React, { useState, useEffect } from "react"
import Heading from "../../common/Heading"
import { API_BASE } from "../../../lib/api"
import "./recent.css"
import RecentCard from "./RecentCard"

const Recent = () => {
  const [listings, setListings] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    setLoading(true)
    setError("")
    fetch(`${API_BASE}/api/listings?limit=6&sort=default`)
      .then((res) => res.json())
      .then((data) => {
        if (data.error) setError(data.error)
        else setListings(data.listings || [])
      })
      .catch(() => setError("Failed to load listings"))
      .finally(() => setLoading(false))
  }, [])

  return (
    <section className='recent padding'>
      <div className='container'>
        <Heading
          title='Recently Listed Properties'
          subtitle="Latest homes and units from Vista Hill Houses. New listings are added regularly, and we can also build to your specifications if you don't find the right fit."
        />
        {error && <p className='recent-error'>{error}</p>}
        {loading && <p className='recent-loading'>Loading...</p>}
        {!loading && !error && <RecentCard listings={listings} />}
      </div>
    </section>
  )
}

export default Recent
